import {HTMLAttributes} from 'react'
import clsx from 'clsx'

type CardProps = {
    variant?: 'default' | 'desructive'
} & HTMLAttributes<HTMLDivElement>

const Card = ({children, className, variant = 'default', ...props}: CardProps) => (
    <div
        className={clsx(
            'backdrop-blur-md shadow-lg rounded-lg transform-gpu',
            {
                'bg-gray-700/10': variant === 'default',
                'bg-red-700/10': variant === 'desructive',
            },
            className
        )}
        {...props}
    >
        {children}
    </div>
)

export default Card
